import { gql } from '@apollo/client';

export default gql`
  query exoWallet {
    exoWallet
  }
`;
